// angular
// 	.module("HeroPRO")
// 	.directive('hpContactInfo', contactInfo);

import _ from 'lodash';
import './contactInfo.scss';

/* @ngInject */
export default function contactInfo(UserData, $rootScope) {
    const contactInfoController = function () {
        const vm = this;

        vm.isEditEmail = false;

        init();

        /*= =======================================
		 =            Public Functions            =
		 ======================================== */
        vm.trigger_onupdate = function () {
            // this is a way to provide a parent event that can be executed whenever
            // the model for the directive changes.
            if (vm.onupdate) {
                vm.onupdate();
            }
        };
        vm.checkPrimaryEmail = function () {
            editEmail();
            if (!vm.noconfirm) {
                vm.checkEmailChange();
            }
        };

        vm.checkEmailChange = function () {
            // when the email field is programmatically reset, wipe out the confirm field
            if (!vm.contactInfoForm.txtContactInformationEmail && !vm.contact.Email) {
                vm.contactInfoForm.txtContactInformationConfirmEmail = undefined;
            }
            if (vm.contactInfoForm.txtContactInformationEmail !== undefined) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('inuse', true);
            }
            if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('inuse', true);
            }
            if (vm.email === vm.contact.Email && vm.contactInfoForm.$valid) {
                vm.isEmailConfirmed = false;
                vm.isEditEmail = false;
            } else if (vm.contact.Email !== vm.confirmEmail && !_.isEmpty(vm.confirmEmail)) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', false);
                }
                vm.errorMessage = 'Emails do not match';
                vm.isEmailConfirmed = false;
            } else if (vm.contact.Email !== vm.confirmEmail && _.isEmpty(vm.confirmEmail) && vm.editor === true) {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', false);
                }
                vm.errorMessage = 'Emails do not match';
                vm.isEmailConfirmed = false;
            } else if (vm.contact.Email !== vm.confirmEmail && _.isEmpty(vm.confirmEmail) && vm.editor === false) {
                vm.isEmailConfirmed = false;
                vm.isEditEmail = true;
            } else {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('nomatch', true);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail !== undefined) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('nomatch', true);
                }
                vm.errorMessage = '';
                if (vm.email === vm.contact.Email) {
                    vm.isEmailConfirmed = false;
                    vm.isEditEmail = false;
                } else if ((vm.contact.Email === vm.confirmEmail && vm.contactInfoForm.$valid) || (vm.contact.Email === vm.confirmEmail && vm.contactInfoForm.$dirty)) {
                    if (!_.isEmpty(vm.contact.Email)) {
                        vm.isEmailConfirmed = true;
                    } else {
                        vm.isEmailConfirmed = false;
                    }
                }
            }
        };

        vm.validatePhone = function () {
            if (vm.contactInfoForm.txtContactInformationPhone.$invalid) {
                vm.isPhoneInvalid = true;
            } else {
                vm.isPhoneInvalid = false;
            }
            vm.trigger_onupdate();
        };
        vm.validateMobilePhone = function () {
            if (vm.contactInfoForm.txtContactInformationMobilePhone.$invalid) {
                vm.isMobilePhoneInvalid = true;
            } else {
                vm.isMobilePhoneInvalid = false;
            }
            vm.trigger_onupdate();
        };

        /* -----  End of Public Functions  ------*/

        /*= =======================================
		 =            Private Functions            =
		 ======================================== */
        function init() {
            getElevatedAccess();
        }

        function editEmail() {
            if (!_.isEmpty(vm.email) || !vm.noconfirm) {
                vm.isEditEmail = true;
            }
        }

        function getElevatedAccess() {
            UserData.getUserData().then((response) => {
                if (response.HasElevatedAccess === undefined || response.HasElevatedAccess === null) {
                    vm.isAdmin = false;
                } else {
                    vm.isAdmin = true;
                }
                vm.email = vm.contact.Email;
            });
        }

        $rootScope.$on('EmailInUse', () => {
            _.delay(() => {
                vm.contactInfoForm.txtContactInformationEmail.$setValidity('inuse', false);
                if (vm.contactInfoForm.txtContactInformationConfirmEmail) {
                    vm.contactInfoForm.txtContactInformationConfirmEmail.$setValidity('inuse', false);
                }
                vm.errorMessage = 'Email is in use.';
                vm.isEmailConfirmed = false;
                $rootScope.$apply();
            });
        });
    };

    return {
        replace: true,
        restrict: 'E',
        scope: {
            contact: '=',
            required: '=',
            submitted: '=',
            toggleOff: '=',
            editor: '=',
            showMobilePhone: '=',
            onupdate: '=',
            noconfirm: '=',
        },
        require: '^form',
        templateUrl: 'app/accounts/offices/info/contactInfo/contactInfo.html',
        controller: contactInfoController,
        controllerAs: 'contactInfo',
        bindToController: true,
    };
}



// WEBPACK FOOTER //
// ./src/app/accounts/offices/info/contactInfo/hpContactInfo.js